module.exports = __webpack_public_path__ + "images/Percent.df349cb75021afa037949c29a4ddef24.svg";